export const createRangeObject = ({
  PRIMARY_KEY,
  topIndex,
  leftIndex,
  rightIndex,

  artist_name,
  city,
  booking_location_name,
  booking_status_name
}) => {
  return {
    PRIMARY_KEY,
    topIndex,
    leftIndex,
    rightIndex,

    artist_name,
    city,
    booking_location_name,
    booking_status_name
  }
}

